module.exports = __webpack_public_path__ + "media/katarina_outside.0fa2b5c9.mp4";